import React from "react";
import CategoryPage from "./CategoryPage";

export default function LoToPage() {
  return (
    <CategoryPage
      categoryMatch="loto"
      title="LoTo: Occupaional Safety"
      subtitle="Lockout/tagout systems and occupational safety equipment to protect workers and equipment."
      searchPlaceholder="Search LoTo products..."
    />
  );
}